// Tailwind v2: no slash opacity (bg-black/60), no bracket sizes (text-[10px]), use yellow-* not amber-*.

export const fitnessProfileModalBackdropClassName =
	'fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-50';

export const fitnessProfileModalPanelClassName =
	'w-full min-w-0 overflow-hidden rounded-2xl border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-card p-5 shadow-xl dark:shadow-2xl text-gray-900 dark:text-dark-text';

export const fitnessProfileFormErrorClassName =
	'rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700 dark:border-red-800 dark:bg-red-900 dark:bg-opacity-25 dark:text-red-300';

export const fitnessProfileSurfaceCardClassName =
	'rounded-2xl border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-card shadow-sm';

export const fitnessProfileSurfaceMutedClassName =
	'rounded-xl border border-gray-300 dark:border-dark-border bg-gray-50 dark:bg-dark-bg p-3';

export const readingModalInputClassName =
	'w-full min-w-0 max-w-full box-border rounded-xl border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-bg px-3 py-2 text-gray-900 dark:text-dark-text outline-none transition placeholder:text-gray-400 dark:placeholder:text-dark-text-secondary focus:border-blue-500 focus:ring-2 focus:ring-blue-500 dark:focus:border-blue-400 dark:focus:ring-blue-400';

/** Outer shell matches readingModalInputClassName; inner input avoids iOS date overflow (application.scss). */
export function fitnessProfileDateFieldShellClassName(hasError = false) {
	const base =
		'flex w-full min-w-0 items-center overflow-hidden rounded-xl border bg-white dark:bg-dark-bg px-3 py-2 transition dark:[color-scheme:dark]';
	if (hasError) {
		return `${base} border-red-400 dark:border-red-500 focus-within:border-red-500 dark:focus-within:border-red-400 focus-within:ring-2 focus-within:ring-red-500 dark:focus-within:ring-red-400`;
	}
	return `${base} border-gray-300 dark:border-dark-border focus-within:border-blue-500 dark:focus-within:border-blue-400 focus-within:ring-2 focus-within:ring-blue-500 dark:focus-within:ring-blue-400`;
}

export const fitnessProfileDateFieldClassName = `mt-1 ${fitnessProfileDateFieldShellClassName()}`;

export const fitnessProfileDateInputClassName =
	'fitness-profile-date-input flex-1 min-w-0 w-0 border-0 bg-transparent p-0 text-base text-gray-900 dark:text-dark-text outline-none';

export const readingActionButtonClassName =
	'shrink-0 flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 dark:border-dark-border bg-white bg-opacity-80 dark:bg-dark-bg text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-gray-700 dark:hover:border-gray-500 transition';
